import { mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { IRequestPayload } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';
import { IPricingProfileDocument } from 'pricing/types';

export const getPricingProfileDocuments = async (
  requestPayload: IRequestPayload,
  signal?: AbortSignal
) => {
  const { data } = await partfinitiClient.get(
    `/corporate_v2/pricing-profile-document-list/documents?${getQueryStringToSnakeCase(
      requestPayload
    )}`,
    signal
  );

  return mapRecordsFromServer<IPricingProfileDocument>(data.data, data.recordsFiltered);
};

export const removePricingProfileDocument = async (data: {
  pricingProfileId: number;
  ids: number[];
}) => {
  return partfinitiClient.postForm('/corporate_v2/pricing-profile-document-edit/remove', data);
};

export const savePricingProfileDocument = async (data: {
  name: string;
  fileId: number;
  pricingProfileId: number;
}) => {
  return partfinitiClient.postForm('/corporate_v2/pricing-profile-document-edit/save', {
    corporatePricingProfileDocument: data,
  });
};
